import main from '../main';
import components from './components';
import globals from './globals';
import pages from './pages';
const zonajobs = Object.assign(Object.assign(Object.assign(Object.assign({ portal: 'zonajobs' }, main), globals), components), pages);
export default zonajobs;
